import { render, staticRenderFns } from "./DispositionTypes.vue?vue&type=template&id=036cdcc4&"
import script from "./DispositionTypes.vue?vue&type=script&lang=js&"
export * from "./DispositionTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports